module.exports = __webpack_public_path__ + "img/34200.b9469503.jpg";